(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["fenye"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('saysole-ai-tabs')) {
    class SaysoleAiTabs extends HTMLElement {
      connectedCallback() {
        if (this.dataset.initialized === 'true') return;
        this.dataset.initialized = 'true';

        this.tabs = Array.from(this.querySelectorAll('[role="tab"]'));
        this.panels = Array.from(this.querySelectorAll('[role="tabpanel"]'));

        this.tabs.forEach((tab, index) => {
          tab.addEventListener('click', () => this.activate(index, false));
          tab.addEventListener('keydown', (event) => this.onKeydown(event, index));
        });

        this.addEventListener('shopify:block:select', (event) => {
          const blockId = event.detail && event.detail.blockId;
          if (!blockId) return;
          const index = this.tabs.findIndex((tab) => tab.dataset.blockId === blockId);
          if (index >= 0) this.activate(index, false);
        });
      }

      activate(index, moveFocus) {
        if (!this.tabs[index] || !this.panels[index]) return;

        this.tabs.forEach((tab, tabIndex) => {
          const isActive = tabIndex === index;
          tab.classList.toggle('is-active', isActive);
          tab.setAttribute('aria-selected', String(isActive));
          tab.tabIndex = isActive ? 0 : -1;
        });

        this.panels.forEach((panel, panelIndex) => {
          const isActive = panelIndex === index;
          panel.classList.toggle('is-active', isActive);
          panel.hidden = !isActive;
        });

        if (moveFocus) this.tabs[index].focus({ preventScroll: true });
      }

      onKeydown(event, index) {
        let nextIndex = index;

        if (event.key === 'ArrowRight') nextIndex = (index + 1) % this.tabs.length;
        if (event.key === 'ArrowLeft') nextIndex = (index - 1 + this.tabs.length) % this.tabs.length;
        if (event.key === 'Home') nextIndex = 0;
        if (event.key === 'End') nextIndex = this.tabs.length - 1;

        if (nextIndex !== index) {
          event.preventDefault();
          this.activate(nextIndex, true);
        }
      }
    }

    customElements.define('saysole-ai-tabs', SaysoleAiTabs);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["maidian"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('saysole-feature-showcase')) {
    class SaysoleFeatureShowcase extends HTMLElement {
      connectedCallback() {
        this.track = this.querySelector('[data-sfs-track]');
        this.cards = Array.from(this.querySelectorAll('[data-sfs-card]'));
        this.prevButton = this.querySelector('[data-sfs-prev]');
        this.nextButton = this.querySelector('[data-sfs-next]');
        this.progress = this.querySelector('[data-sfs-progress]');
        this.current = this.querySelector('[data-sfs-current]');

        if (!this.track || this.cards.length < 2) return;

        this.onScroll = this.update.bind(this);
        this.onResize = this.update.bind(this);
        this.onPrev = () => this.move(-1);
        this.onNext = () => this.move(1);

        this.track.addEventListener('scroll', this.onScroll, { passive: true });
        window.addEventListener('resize', this.onResize);
        this.prevButton?.addEventListener('click', this.onPrev);
        this.nextButton?.addEventListener('click', this.onNext);
        requestAnimationFrame(() => this.update());
      }

      disconnectedCallback() {
        this.track?.removeEventListener('scroll', this.onScroll);
        window.removeEventListener('resize', this.onResize);
        this.prevButton?.removeEventListener('click', this.onPrev);
        this.nextButton?.removeEventListener('click', this.onNext);
      }

      activeIndex() {
        if (!this.track) return 0;
        const left = this.track.scrollLeft;
        let closest = 0;
        let distance = Infinity;
        this.cards.forEach((card, index) => {
          const delta = Math.abs(card.offsetLeft - left - 16);
          if (delta < distance) {
            distance = delta;
            closest = index;
          }
        });
        return closest;
      }

      move(direction) {
        const nextIndex = Math.max(0, Math.min(this.cards.length - 1, this.activeIndex() + direction));
        this.track.scrollTo({ left: this.cards[nextIndex].offsetLeft - 16, behavior: 'smooth' });
      }

      update() {
        const index = this.activeIndex();
        const ratio = this.cards.length > 1 ? index / (this.cards.length - 1) : 1;
        if (this.progress) this.progress.style.width = `${Math.max(8, ratio * 100)}%`;
        if (this.current) this.current.textContent = String(index + 1).padStart(2, '0');
        if (this.prevButton) this.prevButton.disabled = index === 0;
        if (this.nextButton) this.nextButton.disabled = index === this.cards.length - 1;
      }
    }

    customElements.define('saysole-feature-showcase', SaysoleFeatureShowcase);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["maidian2"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('saysole-feature-grid-v5')) {
    class SaysoleFeatureGridV5 extends HTMLElement {
      connectedCallback() {
        this.track = this.querySelector('[data-sfs-track]');
        this.cards = Array.from(this.querySelectorAll('[data-sfs-card]'));
        this.prevButton = this.querySelector('[data-sfs-prev]');
        this.nextButton = this.querySelector('[data-sfs-next]');
        this.progress = this.querySelector('[data-sfs-progress]');
        this.current = this.querySelector('[data-sfs-current]');
        if (!this.track || this.cards.length < 2 || this.dataset.mobileLayout !== 'carousel') return;
        this.onScroll = this.update.bind(this);
        this.onResize = this.update.bind(this);
        this.onPrev = () => this.move(-1);
        this.onNext = () => this.move(1);
        this.track.addEventListener('scroll', this.onScroll, { passive: true });
        window.addEventListener('resize', this.onResize);
        this.prevButton?.addEventListener('click', this.onPrev);
        this.nextButton?.addEventListener('click', this.onNext);
        requestAnimationFrame(() => this.update());
      }
      disconnectedCallback() {
        this.track?.removeEventListener('scroll', this.onScroll);
        window.removeEventListener('resize', this.onResize);
        this.prevButton?.removeEventListener('click', this.onPrev);
        this.nextButton?.removeEventListener('click', this.onNext);
      }
      activeIndex() {
        if (!this.track) return 0;
        const left = this.track.scrollLeft;
        let closest = 0;
        let distance = Infinity;
        this.cards.forEach((card, index) => {
          const delta = Math.abs(card.offsetLeft - left - 16);
          if (delta < distance) { distance = delta; closest = index; }
        });
        return closest;
      }
      move(direction) {
        const nextIndex = Math.max(0, Math.min(this.cards.length - 1, this.activeIndex() + direction));
        this.track.scrollTo({ left: this.cards[nextIndex].offsetLeft - 16, behavior: 'smooth' });
      }
      update() {
        const index = this.activeIndex();
        const ratio = this.cards.length > 1 ? index / (this.cards.length - 1) : 1;
        if (this.progress) this.progress.style.width = `${Math.max(8, ratio * 100)}%`;
        if (this.current) this.current.textContent = String(index + 1).padStart(2, '0');
        if (this.prevButton) this.prevButton.disabled = index === 0;
        if (this.nextButton) this.nextButton.disabled = index === this.cards.length - 1;
      }
    }
    customElements.define('saysole-feature-grid-v5', SaysoleFeatureGridV5);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tongdian"] && !Shopify.designMode) return;
  try {
    
  (() => {
    class SaysolePainTabs {
      constructor(root) {
        this.root = root;
        this.tabs = Array.from(root.querySelectorAll('[role="tab"]'));
        this.panels = Array.from(root.querySelectorAll('[role="tabpanel"]'));
        this.descriptions = Array.from(root.querySelectorAll('[data-description-index]'));
        this.toggle = root.querySelector('.saysole-pain-tabs__toggle');
        this.autoplay = root.dataset.autoplay === 'true' && this.tabs.length > 1;
        this.interval = Number(root.dataset.interval) || 6000;
        this.pauseOnHover = root.dataset.pauseOnHover === 'true';
        this.activeIndex = Math.max(0, this.tabs.findIndex((tab) => tab.getAttribute('aria-selected') === 'true'));
        this.timer = null;
        this.manuallyPaused = false;
        this.temporarilyPaused = false;
        this.reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

        this.bindEvents();
        this.syncMedia();
        this.restartTimer();
      }

      bindEvents() {
        this.tabs.forEach((tab, index) => {
          tab.addEventListener('click', () => {
            this.activate(index, true);
          });

          tab.addEventListener('keydown', (event) => {
            let nextIndex = null;
            if (event.key === 'ArrowRight' || event.key === 'ArrowDown') nextIndex = (index + 1) % this.tabs.length;
            if (event.key === 'ArrowLeft' || event.key === 'ArrowUp') nextIndex = (index - 1 + this.tabs.length) % this.tabs.length;
            if (event.key === 'Home') nextIndex = 0;
            if (event.key === 'End') nextIndex = this.tabs.length - 1;

            if (nextIndex !== null) {
              event.preventDefault();
              this.activate(nextIndex, true);
              this.tabs[nextIndex].focus();
            }
          });
        });

        if (this.toggle) {
          this.toggle.addEventListener('click', () => {
            this.manuallyPaused = !this.manuallyPaused;
            this.toggle.setAttribute('aria-pressed', String(this.manuallyPaused));
            this.toggle.setAttribute('aria-label', this.manuallyPaused ? 'Resume auto-rotation' : 'Pause auto-rotation');
            this.root.classList.toggle('is-manually-paused', this.manuallyPaused);
            this.updatePausedState();
          });
        }

        if (this.pauseOnHover) {
          this.root.addEventListener('mouseenter', () => {
            this.temporarilyPaused = true;
            this.updatePausedState();
          });
          this.root.addEventListener('mouseleave', () => {
            this.temporarilyPaused = false;
            this.updatePausedState();
          });
          this.root.addEventListener('focusin', () => {
            this.temporarilyPaused = true;
            this.updatePausedState();
          });
          this.root.addEventListener('focusout', (event) => {
            if (!this.root.contains(event.relatedTarget)) {
              this.temporarilyPaused = false;
              this.updatePausedState();
            }
          });
        }

        document.addEventListener('visibilitychange', () => {
          this.temporarilyPaused = document.hidden;
          this.updatePausedState();
        });

        document.addEventListener('shopify:block:select', (event) => {
          const index = this.tabs.findIndex((tab) => tab.dataset.blockId === event.detail.blockId);
          if (index >= 0) {
            this.activate(index, true);
            this.manuallyPaused = true;
            this.root.classList.add('is-manually-paused');
            if (this.toggle) {
              this.toggle.setAttribute('aria-pressed', 'true');
              this.toggle.setAttribute('aria-label', 'Resume auto-rotation');
            }
            this.updatePausedState();
          }
        });
      }

      activate(index, userInitiated = false) {
        if (!this.tabs[index]) return;

        this.activeIndex = index;
        this.tabs.forEach((tab, tabIndex) => {
          const isActive = tabIndex === index;
          tab.setAttribute('aria-selected', String(isActive));
          tab.tabIndex = isActive ? 0 : -1;
        });

        this.panels.forEach((panel, panelIndex) => {
          panel.hidden = panelIndex !== index;
        });

        this.descriptions.forEach((description, descriptionIndex) => {
          description.hidden = descriptionIndex !== index;
        });

        this.tabs[index].scrollIntoView({ behavior: this.reducedMotion ? 'auto' : 'smooth', block: 'nearest', inline: 'center' });
        this.syncMedia();

        if (userInitiated) this.restartTimer();
      }

      syncMedia() {
        this.panels.forEach((panel, index) => {
          const video = panel.querySelector('video');
          if (!video) return;

          if (index === this.activeIndex && !this.isPaused()) {
            const promise = video.play();
            if (promise && typeof promise.catch === 'function') promise.catch(() => {});
          } else {
            video.pause();
          }
        });
      }

      isPaused() {
        return this.manuallyPaused || this.temporarilyPaused || this.reducedMotion;
      }

      updatePausedState() {
        const paused = this.isPaused();
        this.root.classList.toggle('is-paused', paused);

        if (paused) {
          window.clearTimeout(this.timer);
          this.timer = null;
        } else {
          this.restartTimer();
        }

        this.syncMedia();
      }

      restartProgress() {
        const progress = this.tabs[this.activeIndex]?.querySelector('.saysole-pain-tabs__progress span');
        if (!progress) return;
        progress.style.animation = 'none';
        progress.offsetHeight;
        progress.style.animation = '';
      }

      restartTimer() {
        window.clearTimeout(this.timer);
        this.timer = null;

        if (!this.autoplay || this.isPaused()) return;

        this.restartProgress();
        this.timer = window.setTimeout(() => {
          this.activate((this.activeIndex + 1) % this.tabs.length);
          this.restartTimer();
        }, this.interval);
      }
    }

    const init = (scope = document) => {
      scope.querySelectorAll('.saysole-pain-tabs').forEach((root) => {
        if (!root.dataset.initialized) {
          root.dataset.initialized = 'true';
          new SaysolePainTabs(root);
        }
      });
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => init());
    } else {
      init();
    }

    document.addEventListener('shopify:section:load', (event) => init(event.target));
  })();

  } catch(e) { console.error(e); }
})();
})();
